export enum ButtonTypeEnum {
  PRIMARY = 'button-primary',
  OUTLINE = 'button-outline',
}

export type ButtonTypeEnumValues = `${ButtonTypeEnum}`;
